export default "__VITE_ASSET__a288d56e__"